import { render, staticRenderFns } from "./commendCor.vue?vue&type=template&id=376eed9c&scoped=true&"
import script from "./commendCor.vue?vue&type=script&lang=js&"
export * from "./commendCor.vue?vue&type=script&lang=js&"
import style0 from "./commendCor.vue?vue&type=style&index=0&id=376eed9c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376eed9c",
  null
  
)

export default component.exports